import Login from './views/Login.svelte'
import Recovery from './views/Recovery.svelte'
import ResetPassword from './views/ResetPassword.svelte'
import PublicLayout from './views/Layout.svelte'
import Home from './views/Home.svelte'
import HomeFiscalia from './views/HomeFiscalia.svelte'
import AsistenciaGratuita from './views/AsistenciaGratuita.svelte'
import MisDenuncias from './views/MisDenuncias.svelte';

import Denuncia from './views/Denuncia.svelte'
import DenunciaEmpresa from './views/DenunciaEmpresa.svelte'
import DenunciaFiscalia from './views/DenunciaFiscalia.svelte'

import DenunciaExito from './views/DenunciaExito.svelte'

import Asistencia from './views/Asistencia.svelte'
import AsistenciaEmpresa from './views/AsistenciaEmpresa.svelte'
import AsistenciaExito from './views/Asistencia.svelte'

import EstadoDenuncia from './views/EstadoDenuncia.svelte';
import AuthService from './authService';
import PrivateLayout from './views/PrivateLayout.svelte'

import TerminosCondiciones from './views/TerminosCondiciones.svelte'
import TerminosCondicionesFiscalia from './views/TerminosCondicionesFiscalia.svelte'


function isLogged() {
    let isAuth = true;

    const token = localStorage.getItem('token');

    if (!token) {
        isAuth = false;
    }

    return isAuth;
}

const routes = [
    {
        name: '/', component: Home, layout: PublicLayout,
    },
    {
        name: '/fiscalia', component: HomeFiscalia, layout: PublicLayout,
    },
    {
        name: '/fiscalia/denuncia', component: DenunciaFiscalia, layout: PublicLayout
    },
    {
        name: '/fiscalia/terms-conditions', component: TerminosCondicionesFiscalia, layout: PublicLayout
    },
    {
        name: '/denuncia', component: Denuncia, layout: PublicLayout
    },
    {
        name: '/denuncia/:company', component: DenunciaEmpresa, layout: PublicLayout
    },
    {
        name: '/denuncia-exito/:id', component: DenunciaExito, layout: PublicLayout
    },
    {
        name: '/asistencia', component: Asistencia, layout: PublicLayout
    },
    {
        name: '/asistencia/:company', component: AsistenciaEmpresa, layout: PublicLayout
    },
    {
        name: '/asistencia-exito/:id', component: AsistenciaExito, layout: PublicLayout
    },
    {
        name: '/estado-denuncia', component: EstadoDenuncia, layout: PublicLayout
    },
    {
        name: '/login', component: Login,
    },
    {
        name: '/recovery', component: Recovery,
    },
    {
        name: '/reset-password/:id', component: ResetPassword,
    },
    {
        name: '/denuncias', component: MisDenuncias, layout: PublicLayout,
        onlyIf: { guard: isLogged, redirect: '/login' },
    },
    {
        name: '/terms-conditions', component: TerminosCondiciones, layout: PublicLayout
    }
]

export { routes }